import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import { ChakraProvider, extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SWRConfig } from 'swr';

import Dashboard from './routes/Dashboard';
import NotFound from './routes/NotFound';
import { Login } from './routes/Login';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { createAxios } from './services/httpService';
import { AuthProvider } from './context/AuthProvider';

const theme = extendTheme(
  {
    config: {
      initialColorMode: 'light',
    },
    fonts: {
      body: 'Inter',
      heading: 'Inter',
    },
    styles: {
      global: {
        'html, body, #root': { height: '100%' },
      },
    },
    components: {
      Badge: {
        baseStyle: { textAlign: 'center' },
        sizes: {
          sm: {
            minH: '1.25rem',
            minW: '1.25rem',
            lineHeight: '1.25rem',
            fontSize: 'xs',
            px: 1,
            py: 0.5,
          },
        },
      },
      Link: {
        baseStyle: ({ colorMode }) => ({
          color: colorMode === 'dark' ? 'blue.200' : 'blue.500',
        }),
      },
    },
  },
  withDefaultColorScheme({ colorScheme: 'blue' })
);

const SWRConfigObj = {
  fetcher: createAxios().get,
};

function App() {
  return (
    <ChakraProvider theme={theme}>
      <SWRConfig value={SWRConfigObj}>
        <AuthProvider>
          <Routes>
            <Route element={<NotFound />} path='*' />
            <Route element={<Login />} path='login' />
            <Route
              index
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </SWRConfig>
    </ChakraProvider>
  );
}

export default App;
